import Gleap from "./Gleap";

export default Gleap;
